import { gql } from '@apollo/client';

export const GET_CUSTOM_PACING_REPORT_LIST = gql`
  query customPacingReportList($paginationOptions: PaginationOptions, $sortOptions: CustomPacingReportListSortOptions) {
    getCustomPacingReportList(paginationOptions: $paginationOptions, sortOptions: $sortOptions) {
      edges {
        node {
          id
          name
          createdAt
          createdByUserEmail
        }
      }
      pageInfo {
        hasNextPage
      }
      total
    }
  }
`;
